// extracted by mini-css-extract-plugin
export default {"buttonInner":"TextInput_buttonInner__bFiZm","container":"TextInput_container__Gq1V5","permaPlaceholder":"TextInput_permaPlaceholder__B5YJL"};